import { sagaMiddleware } from '@launcher/components/App/reduxSagaContext';
import { configureStore, Middleware } from '@reduxjs/toolkit';
import { EnvManager } from '@services/environment/environment.service';
import { monitoring } from '@services/monitoring';

import { history } from './history';
import loggingMiddleware from './middleware/loggingMiddleware';
import { createRootReducer } from './reducer';
import { rootSaga } from './sagas';
import { documentProcessingMiddleware } from './uploadDocuments/middleware/documentProcessing.middleware';

export const getStore = (middlewares: Middleware[] = []) => {
  const store = configureStore({
    reducer: createRootReducer(),
    enhancers: [monitoring.reduxEnhancer],
    middleware: (getDefaultMiddleware) => [
      sagaMiddleware,
      ...getDefaultMiddleware({ serializableCheck: false }),
      loggingMiddleware,
      documentProcessingMiddleware,
      ...middlewares,
    ],
    devTools: process.env.NODE_ENV !== 'production',
  });

  sagaMiddleware.run(rootSaga);

  return store;
};

const store = getStore();

// We allow access of the store only when we are in a Cypress environnement
if (EnvManager.getName() === 'octopus') {
  window.__store__ = store;

  window.__history__ = history;
}

export { store, history };
